module.exports = __webpack_public_path__ + "static/media/sidebarPattern.eb40ff8f.png";